
import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
// 誓約・同意既読フラグ検索
export const readFlagSearch = (userCd) => {
    return http.requestGet(apiUrl.apiUrl_ReadFlag + '?userCd=' + userCd)
}
// 誓約・同意既読フラグ検索
export const readFlagUpdate = (saveParams) => {
    return http.requestPost(apiUrl.apiUrl_ReadFlag, saveParams)
}
// お知らせ詳細検索
export const noticeDetailSearch = (userCd) => {
    return http.requestGet(apiUrl.apiUrl_NoticeDetailSearch + '?userCd=' + userCd)
}
//PDF查询
export const PDFFile_get = (PDFPath) => {
    return http.requestQuickGetImage(apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(PDFPath) + '&resizeCd=0')
}





// WEBPACK FOOTER //
// ./src/module/api/i_0011.js